import { createContext, useCallback, useContext, useState } from 'react'

import {
  IAppConfigContextProps,
  IAppConfigProviderProps,
} from 'types/appConfigProvider'

const defaultAppConfig: IAppConfigContextProps = {
  userLocale: '',
  onUserLocale: () => {},
}

const AppConfigContext = createContext<IAppConfigContextProps>(defaultAppConfig)

const AppConfigProvider = ({ children }: IAppConfigProviderProps) => {
  const [userLocale, setUserLocale] = useState('en-US')

  const onUserLocale = useCallback((value: string) => {
    setUserLocale(value)
  }, [])

  return (
    <AppConfigContext.Provider
      value={{
        userLocale,
        onUserLocale,
      }}
    >
      {children}
    </AppConfigContext.Provider>
  )
}

const useAppConfig = () => {
  return useContext(AppConfigContext)
}

export { AppConfigContext, AppConfigProvider, useAppConfig }
